import { render, staticRenderFns } from "./LoaderReport.vue?vue&type=template&id=7fb1a9da&scoped=true"
import script from "./LoaderReport.vue?vue&type=script&lang=ts"
export * from "./LoaderReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb1a9da",
  null
  
)

export default component.exports